import { requestApi } from "../axios";

export function getListCampaign(limit, offset, appId, search) {
  let query = `/list?limit=${limit}&offset=${offset}&partnerAppId=${appId}&search=${search || ""}`;
  return requestApi(`/admin/config-campaign${query}`, "GET");
}

export function getListTagsApi() {
  return requestApi(`/admin/config-campaign/list-tags?limit=100&offset=0`, "GET");
}

export function updateCampaignToTagApi(id, body) {
  return requestApi(`/admin/config-campaign/${id}`, "PUT", body);
}

export function addTagApi(body) {
  return requestApi(`/admin/config-campaign/create-tag`, "POST", body);
}